// components/workflow/StepHistoryModal.jsx
import React from "react";
import { CHECK_IN_PHOTO } from "../../utils/Contants";
import TicketComponent from "./TicketComponent";
import ReceiptComponent from "./ReceiptComponent";

const StepHistoryModal = ({
  isOpen,
  onClose,
  instance,
  title = "Step History",
}) => {
  if (!isOpen || !instance) return null;

  const renderSubmittedData = (data, depth = 0, fieldName = "") => {
    if (!data || typeof data !== "object") {
      return <span>{data?.toString() || "-"}</span>;
    }

    // Handle ticket_summary case
    if (fieldName === "ticket_summary") {
      return <TicketComponent data={data} fieldName={fieldName} />;
    }

    // Handle receipt case
    if (fieldName === "reciept_image" || fieldName === "receipt") {
      return <ReceiptComponent data={data} fieldName={fieldName} />;
    }

    if (Array.isArray(data)) {
      return (
        <ul className="list-unstyled ms-3">
          {data.map((item, idx) => (
            <li key={idx}>{renderSubmittedData(item, depth + 1)}</li>
          ))}
        </ul>
      );
    }

    return (
      <ul className={`list-unstyled ${depth > 0 ? "ms-3" : ""}`}>
        {Object.entries(data).map(([key, value]) => {
          const isImageField =
            key.toLowerCase().includes("image") ||
            key.toLowerCase().includes("photo") ||
            key.toLowerCase().includes("receipt_image");

          const displayKey = key
            .replace(/_/g, " ")
            .replace(/\b\w/g, (c) => c.toUpperCase());

          let displayValue;
          if (value === null || value === undefined) {
            displayValue = "-";
          } else if (typeof value === "object") {
            displayValue = renderSubmittedData(value, depth + 1, key);
          } else {
            if(key === "country_id" || key === "authority_id"){
              console.log("DATA-->",data)
            console.log("KEY-->",key)
            console.log("VALUE-->",value)
return;
            }else{
              displayValue = value.toString();
            }
          
          }

          return (
            <li key={key} className="mb-2 d-flex gap-2 align-items-start">
              <strong className="text-capitalize">{displayKey}:</strong>
              {isImageField && typeof value === "string" && value ? (
                <div className="image-container">
                  <img
                    src={`${CHECK_IN_PHOTO}/${value}`}
                    alt={key}
                    className="img-thumbnail"
                    style={{
                      maxWidth: "150px",
                      maxHeight: "150px",
                    }}
                    onClick={() =>
                      window.open(`${CHECK_IN_PHOTO}/${value}`, "_blank")
                    }
                  />
                </div>
              ) : isImageField && Array.isArray(value) && value.length > 0 ? (
                <div className="d-flex gap-2 flex-wrap">
                  {value.map((img, idx) => (
                    <img
                      key={idx}
                      src={`${CHECK_IN_PHOTO}/${img}`}
                      alt={`${key}-${idx}`}
                      className="img-thumbnail"
                      style={{
                        maxWidth: "150px",
                        maxHeight: "150px",
                      }}
                      onClick={() =>
                        window.open(`${CHECK_IN_PHOTO}/${img}`, "_blank")
                      }
                    />
                  ))}
                </div>
              ) : (
                <div>{displayValue}</div>
              )}
            </li>
          );
        })}
      </ul>
    );
  };

  return (
    <div
      className="modal fade show d-block"
      tabIndex="-1"
      role="dialog"
      style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
      onClick={(e) => {
        if (e.target.classList.contains("modal")) {
          onClose();
        }
      }}
    >
      <div className="modal-dialog modal-lg modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">{title}</h5>
          </div>
          <div className="modal-body">
            {instance.step_history &&
            Array.isArray(instance.step_history) &&
            instance.step_history.length > 0 ? (
              <div className="accordion" id="stepHistoryAccordion">
                {instance.step_history.map((step, index) => {
                  const submittedData =
                    step.submitted_data &&
                    typeof step.submitted_data === "object"
                      ? step.submitted_data
                      : {};

                  return (
                    <div className="accordion-item" key={index}>
                      <h2 className="accordion-header" id={`heading${index}`}>
                        <button
                          className="accordion-button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target={`#collapse${index}`}
                          aria-expanded={index === 0}
                          aria-controls={`collapse${index}`}
                        >
                          <span className="text-primary-400">
                            Step {index + 1}: {step.step_label || "-"}{" "}
                            {/* (Submitted at:{" "}
                            {step.submitted_at || "Unknown date"}) */}
                          </span>
                        </button>
                      </h2>
                      <div
                        id={`collapse${index}`}
                        className={`accordion-collapse collapse ${
                          index === 0 ? "show" : ""
                        }`}
                        aria-labelledby={`heading${index}`}
                        data-bs-parent="#stepHistoryAccordion"
                      >
                        <div className="accordion-body">
                          <p>
                            {step.submitted_by && (
                              <div>
                                <strong>Submitted by:</strong>{" "}
                                {step.submitted_by}
                              </div>
                            )}
                            {step.submitted_at && (
                              // <div>
                              //   <strong>Submitted at:</strong>{" "}
                              //   {step.submitted_at}
                              // </div>
                              <div>
                                <strong>Submitted at:</strong>{" "}
                                {new Date(step.submitted_at)
                                  .toLocaleString("en-US", {
                                    year: "numeric",
                                    month: "2-digit",
                                    day: "2-digit",
                                    hour: "2-digit",
                                    minute: "2-digit",
                                    hour12: true,
                                  })
                                  .replace(",", "")}
                              </div>
                            )}
                          </p>
                          <h6>Submitted Data:</h6>
                          {Object.keys(submittedData).length > 0 ? (
                            renderSubmittedData(submittedData)
                          ) : (
                            <p>No data submitted for this step.</p>
                          )}
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            ) : (
              <div className="alert alert-info">
                No step history available for this instance.
              </div>
            )}
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-secondary"
              onClick={onClose}
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StepHistoryModal;
